import l from "./_baseRest.js";
import u from "./_isIterateeCall.js";
function h(d) {
  return l(function(i, e) {
    var f = -1, n = e.length, t = n > 1 ? e[n - 1] : void 0, r = n > 2 ? e[2] : void 0;
    for (t = d.length > 3 && typeof t == "function" ? (n--, t) : void 0, r && u(e[0], e[1], r) && (t = n < 3 ? void 0 : t, n = 1), i = Object(i); ++f < n; ) {
      var a = e[f];
      a && d(i, a, f, t);
    }
    return i;
  });
}
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_createAssigner.js
// module id = 1460
// module chunks = 41